import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'app-spa-guests',
    templateUrl: './spa-guests.component.html',
    styleUrls: ['./spa-guests.component.css']
})
export class SpaGuestsComponent implements OnInit {
    @Input() totalGuests = 1;
    @Output() complete = new EventEmitter();

    guests = []
    error = '';

    constructor() { }

    ngOnInit(): void {
        for (let i = 0; i < this.totalGuests; i++) {
            this.guests.push({
                name: '',
                first_name: '',
                last_name: '',
                is_lead_booker: false,
                membership_number: null,
                customer_id: null
            })
        }
    }

    confirm() {
        const guestsForOutput = [];
        let hasError = false;

        for (let g = 0; g < this.guests.length; g++) {
            if (g < 1) {
                this.guests[g].is_lead_booker = true;
            }

            this.guests[g].name = `${this.guests[g].first_name} ${this.guests[g].last_name}`
            const guest = []
            guest.push(this.guests[g])
            guestsForOutput.push(guest)
            if (this.guests[g].first_name === '' || this.guests[g].last_name === '') {
                hasError = true;
            }
        }

        if (hasError) {
            this.error = 'Please complete all guest names in full';
        } else {
            console.log(guestsForOutput);
            this.complete.emit({ action: true, guestsForOutput });

        }
    }
    close() {
        this.complete.emit({ action: false });
    }


}
